<div class="hd-memory">
  <header class="hd-memory__header">
    <h3 class="hd-memory__title">{{ vm().title }}</h3>
  </header>

  <!-- Algemene uitleg over het geheugencircuit (de twee cheat-sheet-blokken) -->
  @if (vm().circuitBullets.length > 0) {
    <section class="hd-memory__circuit-info">
      <h4 class="hd-memory__circuit-title">{{ vm().circuitTitle }}</h4>
      <ul class="hd-memory__bullets">
        @for (bullet of vm().circuitBullets; track $index) {
          <li class="hd-memory__bullet">{{ bullet }}</li>
        }
      </ul>
    </section>
  }

  <!-- Memory-blokjes + bodygraph-diagram; klikken springt naar de detailsectie -->
  <div class="hd-memory__hero">
    <div class="hd-memory__cards">
      @for (gate of gates; track gate) {
        <button
          type="button"
          class="hd-memory__card-button"
          [attr.data-hero-gate]="gate"
          [title]="vm().jumpHint"
          (click)="scrollToGate(gate)">
          <hd-circuit-gate-card scope="memory" [gate]="gate" [rail]="railFor(gate)" size="compact" />
        </button>
      }
    </div>
    <img class="hd-memory__diagram" [src]="circuitryAsset" [alt]="vm().title" (load)="onDiagramLoad()" />
  </div>

  <!-- Per poort de volledige geheugensectie -->
  <div class="hd-memory__sections">
    @for (gate of gates; track gate) {
      <hd-circuit-gate-section class="hd-memory__section" scope="memory" [gate]="gate" [rail]="railFor(gate)" cardSize="compact" showKeynotes />
    }
  </div>
</div>
